import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  button: {
    height: 24,
    top: 12,
    right: 14,
    width: 24,
    [theme.breakpoints.down('md')]: {
      height: 16,
      right: 5,
      top: 8,
      width: 16,
    },
  },
}));
